import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { useWeb3React } from "@web3-react/core";
import ConditionalLink from "../../helper/Components/ConditionalLink";

function ActionButtonMobile({ taskData }) {
  const { account } = useWeb3React();
const currentDate = new Date();
  const coolDownEndTime = new Date(taskData?.coolDownPeriod);
  const endTime = new Date(taskData?.endTime);
  const reviewStartTime = new Date(taskData?.reviewTimePeriod);
  const reviewEndTime = new Date(taskData?.eviewTimePeriod);

  // Conditionally check for refund eligibility
  const isRefundEligible =
    !taskData?.winnerSelected &&
    !taskData?.isDispute &&
    coolDownEndTime < currentDate &&
    // reviewStartTime < currentDate && // condition without dispute
    taskData?.status !== 'completed';

  const isInReviewPeriod =
    currentDate > endTime &&
    currentDate < reviewEndTime &&
    reviewStartTime < coolDownEndTime;
  // console.log(taskData, 'taskDatataskDatataskData');

  return (
    <>
      {(isRefundEligible || isInReviewPeriod) && (
        <ConditionalLink
          href={`/tasksdetails/${taskData?.id}`}
          className="tasksubmit text-center"
        >
          {/* <img src="/assets/createtask/claimRefund.svg" alt="Claim Refund" /> */}
          Claim Refund
        </ConditionalLink>
      )}
      {(currentDate > endTime &&
        currentDate < new Date(taskData?.reviewTimePeriod)) && (
          <ConditionalLink href={`/tasksdetails/${taskData?.id}`} className="tasksubmit text-center">
           Review
          </ConditionalLink>
        )}
      {((taskData?.user?.walletAddress?.toLowerCase() === account?.toLowerCase()) && (new Date(taskData?.endTime) > new Date()) && parseInt(taskData?.participantCount) === 0) && (
        <ConditionalLink href={`/createtask?edit=${taskData?.id}`} className="tasksubmit text-center">
          {/* <img src="/assets/createtask/edittask.svg" alt="Claim Refund" /> */}
          Edit Task
        </ConditionalLink>
      )}
    </>
  );
}

export default ActionButtonMobile;
